import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  KÖZÖSSÉGI SZOLGÁLAT – KRÉTA-szinkron (admin).
 *
 *  A KRÉTA a közösségi szolgálatot az „Adminisztrációs rendszer" szerepkörben vezeti. A
 *  szinkron egy már felvett KRÉTA-fiókkal lép be (a naplózáshoz megadott belépések közül),
 *  letölti a teljes listát, és beírja ide. A KRÉTÁ-ba NEM ír.
 *
 *  Itt látszik az is, mi vár visszaírásra (itt rögzített vagy módosított tételek), és mely
 *  KRÉTA-tételek tanulóját nem találtuk meg a nyilvántartásban.
 */
@Component({
  selector: 'app-admin-iksz-szinkron',
  templateUrl: './iksz-szinkron.component.html',
  styleUrls: ['./iksz-szinkron.component.scss'],
})
export class IkszSzinkronComponent implements OnInit, OnDestroy {
  intezmeny = '';
  toltodik = true;
  hiba = '';

  b: { forras_allomany: string; automatikus: boolean } = { forras_allomany: '', automatikus: false };
  fiokok: { allomany: string; tanar_nev: string; kreta_user: string }[] = [];
  futasok: any[] = [];
  osszesito: any = null;
  parositatlan: any[] = [];
  visszairando: any[] = [];

  folyamat: any = null;
  ment = false;
  private idozito: any = null;

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    await this.betolt();
  }

  ngOnDestroy() { if (this.idozito) clearInterval(this.idozito); }

  async betolt() {
    this.toltodik = !this.futasok.length;
    this.hiba = '';
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/iksz/beallitas/${this.intezmeny}`));
      this.b = { forras_allomany: r?.forras_allomany || '', automatikus: !!r?.automatikus };
      this.fiokok = r?.fiokok || [];
      this.futasok = r?.futasok || [];
      this.osszesito = r?.osszesito || null;
      this.parositatlan = r?.parositatlan || [];
      this.visszairando = r?.visszairando || [];
      this.folyamat = r?.folyamat || null;
      if (this.folyamat?.fut) this.kovet();
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A beállítás nem tölthető be.';
    } finally {
      this.toltodik = false;
    }
  }

  get valasztottFiok() {
    return this.fiokok.find((f) => f.allomany === this.b.forras_allomany) || null;
  }

  async mentes() {
    this.ment = true;
    try {
      await firstValueFrom(this.http.put(`/api/iksz/beallitas/${this.intezmeny}`, this.b));
      this.data.sendToast('Beállítás mentve.', 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally {
      this.ment = false;
    }
  }

  async szinkron() {
    if (!this.b.forras_allomany) {
      this.data.sendToast('Válaszd ki, melyik KRÉTA-fiókkal lépjen be a szinkron.', 'warning');
      return;
    }
    if (!confirm('Elindítod a szinkront? A rendszer belép a KRÉTÁ-ba, letölti a közösségi szolgálat '
      + 'teljes listáját, és frissíti az itteni nyilvántartást. A KRÉTÁ-ban nem változtat semmit.')) return;
    try {
      await firstValueFrom(this.http.put(`/api/iksz/beallitas/${this.intezmeny}`, this.b));
      const r: any = await firstValueFrom(this.http.post(`/api/iksz/szinkron/${this.intezmeny}`, {
        forras_allomany: this.b.forras_allomany,
      }));
      this.folyamat = r?.folyamat || { fut: true, lepes: 'Indul' };
      this.kovet();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A szinkron nem indult el.', 'error');
    }
  }

  /*  A szinkron fél perctől pár percig tart: a képernyő mutassa, hol tart. */
  private kovet() {
    if (this.idozito) clearInterval(this.idozito);
    this.idozito = setInterval(async () => {
      try {
        const r: any = await firstValueFrom(this.http.get(`/api/iksz/szinkron-allapot/${this.intezmeny}`));
        this.folyamat = r;
        if (!r?.fut) {
          clearInterval(this.idozito);
          this.idozito = null;
          if (r?.hiba) this.data.sendToast(`A szinkron nem sikerült: ${r.hiba}`, 'error');
          else if (r?.eredmeny) this.data.sendToast('A szinkron kész.', 'success');
          await this.betolt();
        }
      } catch { /* a következő körben újra kérdezzük */ }
    }, 2500);
  }
}
